'use client'
import Header from '@/components/layout/main/header'
import Footer from '@/components/layout/main/footer/Footer'
import { useEffect } from 'react'

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Header />
      <div className="max-w-5xl mx-auto mt-[20px] px-4 lg:px-0">
        <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
          Privacy and Policy
        </h3>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            1. Introduction
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`This privacy policy outlines how ExamSolutions collects, uses,
            maintains, and discloses information from users of the
            app.examsolutions.net website ("Site"). By using our Site, you
            signify your acceptance of this policy. If you do not agree to this
            policy, please do not use our Site.`}
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            2. Personal Data Collection
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            We may collect personal identification information in various ways,
            including, but not limited to, when users register on the Site,
            subscribe to a service, or engage in transactions. Users may be
            asked for, as appropriate, name, email address, credit card
            information, etc.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            3. Non-Personal Data Collection
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`We may collect non-personal identification information about users
            whenever they interact with our Site. This may include browser type,
            computer type, technical information about the user's means of
            connection to our Site, etc.`}
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            4. Web Cookies
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`Our Site may use "cookies" to enhance user experience. Users can
            choose to set their web browser to refuse cookies or alert them when
            cookies are being sent.`}
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            5. How We Use Collected Information
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            ExamSolutions may use collected information for the following
            purposes:
          </p>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            <ul className="list-disc pl-5">
              <li>To process transactions.</li>
              <li>To personalize user experience.</li>
              <li>To send periodic emails (e.g., newsletter, updates).</li>
              <li>To improve our Site and services.</li>
            </ul>
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            6. How We Protect User Information
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            We implement appropriate data collection, storage, and processing
            practices, and security measures to protect against unauthorized
            access, alteration, or disclosure of your personal information.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            7. Sharing Personal Data
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`We do not sell, trade, or rent users' personal identification
            information to others. We may share generic aggregated demographic
            information not linked to any personal identification information
            with business partners or trusted affiliates for the purposes
            outlined above.`}
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            8. Third-party Websites
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            Users may find advertising or other content on our Site that links
            to sites and services of third parties. We do not control the
            content or links that appear on these sites. Thus, we are not
            responsible for the practices employed by websites linked to our
            Site.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            9. Changes to This Privacy Policy
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            ExamSolutions reserves the right to update this privacy policy at
            any time. When updated, we will revise the date at the bottom of
            this page. We encourage users to check this page regularly for any
            changes.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            10. Contacting Us
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            For any questions about this Privacy Policy, practices of this site,
            or your dealings with this site, please contact us at the addresses
            provided in the Terms and Conditions.
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}
